import { Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const LabelWithInfo = ({ label, tooltip, style, variant, props }) => (
  <Typography
    variant={variant}
    {...(props?.color !== "none" && { color: props?.color || "inherit" })}
    sx={{
      ...style,
      display: "flex",
      alignItems: "center",
      gap: 0.5,
    }}
  >
    {label}

    {tooltip && (
      <Tooltip title={tooltip} arrow placement="bottom">
        <InfoOutlinedIcon
          color="action"
          sx={{
            cursor: "pointer",
            fontSize: props?.infoSize || 16,
          }}
        />
      </Tooltip>
    )}
  </Typography>
);